import { render } from "./Sidebar.vue?vue&type=template&id=58f523ee&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=58f523ee&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=58f523ee&lang=css"

import exportComponent from "/Users/bobbarnard/Documents/sources/bungalow7-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f523ee"]])

export default __exports__